module.exports = __webpack_public_path__ + "static/media/DigiFleet-logo.344b699a.png";